import { getYachtId } from "./localStorage";
import { getOrigin } from "src/environment";
const apiUrl = getOrigin() + "//api/v1/main.php";
/**
 * Crumb logging function to track data for debugging purposes.
 * Only logs data for approved yacht IDs to reduce spam and focus on specific clients.
 *
 * @param message - A descriptive message about what is being logged
 * @param data - Optional data object to be logged (will be JSON stringified)
 */
export function crumb(message: string, data?: any): void {
  // Try catch to prevent blocking code execution if logging fails
  try {
    // Approval system to cut down on spam - only record data for approved yachts
    const approve: Record<string, boolean> = {
      "a810afbe-3e95-5729-1e8d-1bb8306fd3f0": true,
      "70d7cf3e-271c-11ef-aaf9-02c1fe2db5a5": true,
      "792fa17e-3bd4-11f0-8651-02c1fe2db5a5": true,
      // Add more yacht IDs here as needed
    };

    const yachtId = getYachtId();

    if (approve[yachtId]) {
      // console.log("crumb fired", message, data, yachtId);
      // Only approved yachts/clients so we only record what is going on with that yacht
      // You can also add extra restrictions down to the logbook level here

      fetch(apiUrl, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          request: "crumb",
          params: {
            message,
            data: data ? JSON.stringify(data) : null,
            yachtId,
            timestamp: new Date().toISOString(),
          },
        }),
      })
        .then(res => res.json())
        .then(res => {
          // Optional: Handle successful response
          console.debug("Crumb logged successfully", res);
        })
        .catch(error => {
          // Silent fail - don't log to console in production to avoid spam
          console.debug("Crumb logging failed", error);
        });
    }
  } catch (error) {
    // Silent fail - logging should never break the application
    console.debug("Crumb function error", error);
  }
}
